import { AppLayout } from 'layouts';
import { lazy, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Loadable, Page } from 'components';
import { setRouting } from 'toolkits/redux/routing';
import { Navigate, useRoutes } from 'react-router-dom';

const NotFound = Loadable(lazy(() => import('screens/Authentication/Page404')));
const Dashboard = Loadable(lazy(() => import('screens/ShopAdminRole/Dashboard')));

const UserModel = Loadable(lazy(() => import('models/UserModel')));
const RolesModel = Loadable(lazy(() => import('models/RolesModel')));
const RegionModel = Loadable(lazy(() => import('models/RegionModel')));
const ShippingModel = Loadable(lazy(() => import('models/ShippingModel')));
const BoothModel = Loadable(lazy(() => import('models/BoothModel')));
const ShopModel = Loadable(lazy(() => import('models/ShopModel')));
const UnitModel = Loadable(lazy(() => import('models/UnitModel')));
const CouponCategoryModel = Loadable(lazy(() => import('models/CouponCategoryModel')));
const CouponModel = Loadable(lazy(() => import('models/CouponModel')));
const ProductModel = Loadable(lazy(() => import('models/ProductModel')));
const ProductCategoryModel = Loadable(lazy(() => import('models/ProductCategoryModel')));
const BrandModel = Loadable(lazy(() => import('models/BrandModel')));
const AttributeModel = Loadable(lazy(() => import('models/AttributeModel')));
const AttributeValueModel = Loadable(lazy(() => import('models/AttributeValueModel')));
const AttributeCategoryModel = Loadable(lazy(() => import('models/AttributeCategoryModel')));
const ProductShopModel = Loadable(lazy(() => import('models/ProductShopModel')));
const UserCategoryModel = Loadable(lazy(() => import('models/UserCategoryModel')));
const TaskModel = Loadable(lazy(() => import('models/TaskModel')));
const ModuleModel = Loadable(lazy(() => import('models/ModuleModel')));
const OrderModel = Loadable(lazy(() => import('models/OrderModel')));
const TemporaryModel = Loadable(lazy(() => import('models/TemporaryModel')));

const navConfig = [
  {
    path: '/',
    element: <Navigate to="/app" replace />,
  },
  {
    url: '/',
    path: '/',
    title: 'app',
    inSidebar: true,
    element: <AppLayout />,
    children: [
      {
        url: '/app',
        path: '/app',
        title: 'app',
        inSidebar: true,
        element: <Dashboard />,
      },
      {
        url: '/user',
        path: '/user',
        title: 'users',
        inSidebar: true,
        element: (
          <Page title="UserModel">
            <UserModel />
          </Page>
        ),
      },
      {
        url: '/user-category',
        path: '/user-category',
        title: 'usersCategory',
        inSidebar: true,
        element: (
          <Page title="UserCategoryModel">
            <UserCategoryModel />
          </Page>
        ),
      },
      {
        url: '/shop',
        path: '/shop',
        title: 'shops',
        inSidebar: true,
        element: (
          <Page title="Shops">
            <ShopModel initFilter={{ for_admin: 1 }} />
          </Page>
        ),
      },
      {
        url: '/order',
        path: '/order',
        title: 'orders',
        inSidebar: true,
        element: (
          <Page title="OrderModel">
            <OrderModel initFilter={{ for_admin: 1 }} />
          </Page>
        ),
      },
      {
        url: '/unit',
        path: '/unit',
        title: 'units',
        inSidebar: true,
        element: (
          <Page title="Units">
            <UnitModel />
          </Page>
        ),
      },
      {
        url: '/module',
        path: '/module',
        title: 'modules',
        inSidebar: true,
        element: (
          <Page title="Modules">
            <ModuleModel />
          </Page>
        ),
      },
      {
        url: '/task',
        path: '/task',
        title: 'tasks',
        inSidebar: true,
        element: (
          <Page title="Tasks">
            <TaskModel />
          </Page>
        ),
      },
      {
        url: '/roles',
        path: '/roles',
        title: 'roles',
        inSidebar: true,
        element: (
          <Page title="Roles">
            <RolesModel />
          </Page>
        ),
      },
      {
        url: '/regions',
        path: '/regions',
        title: 'regions',
        inSidebar: true,
        element: (
          <Page title="Regions">
            <RegionModel />
          </Page>
        ),
      },
      {
        url: '/shipping',
        path: '/shipping',
        title: 'shipping',
        inSidebar: true,
        element: (
          <Page title="ShippingModel">
            <ShippingModel initFilter={{ for_admin: 1 }} />
          </Page>
        ),
      },
      {
        url: '/booth',
        path: '/booth',
        title: 'booths',
        inSidebar: true,
        element: (
          <Page title="BoothModel">
            <BoothModel />
          </Page>
        ),
      },
      {
        url: '/coupon-category',
        path: '/coupon-category',
        title: 'couponsCategory',
        inSidebar: true,
        element: (
          <Page title="CouponCategoryModel">
            <CouponCategoryModel />
          </Page>
        ),
      },
      {
        url: '/coupon',
        path: '/coupon',
        title: 'coupons',
        inSidebar: true,
        element: (
          <Page title="CouponModel">
            <CouponModel initFilter={{ for_admin: 1 }} />
          </Page>
        ),
      },
      {
        url: '/product',
        path: '/product',
        title: 'products',
        inSidebar: true,
        element: (
          <Page title="ProductModel">
            <ProductModel initFilter={{ for_admin: 1 }} />
          </Page>
        ),
      },
      {
        url: '/product-shop',
        path: '/product-shop',
        title: 'productShop',
        inSidebar: true,
        element: (
          <Page title="ProductShopModel">
            <ProductShopModel initFilter={{ for_admin: 1 }} />
          </Page>
        ),
      },
      {
        url: '/product-category',
        path: '/product-category',
        title: 'productsCategory',
        inSidebar: true,
        element: (
          <Page title="ProductCategoryModel">
            <ProductCategoryModel initFilter={{ for_admin: 1 }} />
          </Page>
        ),
      },
      {
        url: '/brand',
        path: '/brand',
        title: 'brands',
        inSidebar: true,
        element: (
          <Page title="BrandModel">
            <BrandModel initFilter={{ for_admin: 1 }} />
          </Page>
        ),
      },
      {
        url: '/attribute',
        path: '/attribute',
        title: 'attributes',
        inSidebar: true,
        element: (
          <Page title="AttributeModel">
            <AttributeModel initFilter={{ for_admin: 1 }} />
          </Page>
        ),
      },
      {
        url: '/attribute-category',
        path: '/attribute-category',
        title: 'attributesCategory',
        inSidebar: true,
        element: (
          <Page title="AttributeCategoryModel">
            <AttributeCategoryModel initFilter={{ for_admin: 1 }} />
          </Page>
        ),
      },
      {
        url: '/attribute-value',
        path: '/attribute-value',
        title: 'attributesValue',
        inSidebar: true,
        element: (
          <Page title="AttributeValueModel">
            <AttributeValueModel initFilter={{ for_admin: 1 }} />
          </Page>
        ),
      },
      {
        url: '/temporary',
        path: '/temporary',
        title: 'TemporaryModel',
        inSidebar: true,
        element: (
          <Page title="TemporaryModel">
            <TemporaryModel initFilter={{ for_admin: 1 }} />
          </Page>
        ),
      },
    ],
  },
  {
    path: '/',
    element: <AppLayout />,
    children: [
      {
        path: 'intro',
        element: <Navigate to="/" replace />,
      },
      {
        path: 'sign-in',
        element: <Navigate to="/" replace />,
      },
      {
        path: 'sign-up',
        element: <Navigate to="/" replace />,
      },
      {
        path: 'reset-password',
        element: <Navigate to="/" replace />,
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to="/404" replace />,
  },
];

function cleanRoutes({ url, title, inSidebar, children }) {
  if (inSidebar) {
    if (children && children.length > 0) {
      children = children.map((c) => cleanRoutes(c));
      return { url, title, inSidebar, children };
    }
    return { url, title, inSidebar, children: [] };
  }
  return {};
}

export default function Router() {
  const dispatch = useDispatch();
  useEffect(() => {
    // console.log(navConfig.map((x) => cleanRoutes(x)).filter((x) => x));
    dispatch(setRouting(navConfig.map((x) => cleanRoutes(x)).filter((x) => x)));
  }, []);
  return useRoutes(navConfig);
}
